import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
    // creationFlow
    setCurrentStep (state, step) {
      if (!state.creationFlow) return
      state.creationFlow.currentStep = step
    },
    setFlowResult (state, payload) {
      if (!state.creationFlow) return
      const { key, data } = payload
      state.creationFlow.results[key] = data
    }
  },
  actions: {
    advanceStep ({ state, commit }) {
      if (!state.creationFlow) return
      const next = Math.min(state.creationFlow.currentStep + 1, state.creationFlow.steps.length - 1)
      commit('setCurrentStep', next)
    },
    setResult ({ commit }, payload) {
      commit('setFlowResult', payload)
    }
  },
  modules: {
    creationFlow: {
      namespaced: true,
      state: {
        currentStep: 0,
        steps: [
          'generateTopics',
          'generateScript',
          'synthesizeVoice',
          'selectDigitalHuman',
          'editingOptions',
          'titleAndTags',
          'generateCover',
          'publishVideo'
        ],
        results: {}
      },
      mutations: {},
      actions: {},
      getters: {}
    }
  }
})
